import React from 'react';
import { ArrowForwardRounded, ExploreOffRounded } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PublicPageLayout from '../components/PublicPageLayout';
import errorImg from '../assets/img/errorPage.png';
import { FONT_FAMILY } from '../common/sharedFunctions';

const ink = '#111411';

const Error = () => {
  const { t } = useTranslation();

  return (
    <PublicPageLayout
      contentMaxWidth="sm"
      eyebrow="404"
      icon={<ExploreOffRounded sx={{ fontSize: 23 }} />}
      subtitle={t('page_not_not_found_text')}
      title={t('page_not_not_found')}
    >
      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
        <Box
          component="img"
          src={errorImg}
          alt=""
          sx={{ height: { xs: 155, sm: 190 }, mb: 2.5, objectFit: 'contain', width: 'auto' }}
        />
        <Typography sx={{
          color: '#687168',
          fontFamily: FONT_FAMILY,
          fontSize: '0.96rem',
          lineHeight: 1.7,
          maxWidth: 450,
          mb: 3
        }}>
          {t('page_not_found_support', {
            defaultValue: 'The page may have moved or the address may be incorrect. Return home to continue.'
          })}
        </Typography>
        <Button
          component={Link}
          endIcon={<ArrowForwardRounded />}
          to="/"
          variant="contained"
          sx={{
            backgroundColor: '#B7EE00',
            borderRadius: '13px',
            boxShadow: 'none',
            color: ink,
            fontFamily: FONT_FAMILY,
            fontWeight: 900,
            minHeight: 50,
            px: 3,
            textTransform: 'none',
            '&:hover': { backgroundColor: '#CCFF1C', boxShadow: 'none' }
          }}
        >
          {t('go_to_home')}
        </Button>
      </Box>
    </PublicPageLayout>
  );
};

export default Error;
